import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the survey state domain
 */

const selectSurveyDomain = (state) => state.get("survey", initialState)

/**
 * Other specific selectors
 */
//  GET SURVEY
export const makeSelectIsLoadingSurvey = () =>
  createSelector(selectSurveyDomain, (state) => state.get("isLoadingSurvey"))

export const makeSelectSurveys = () =>
  createSelector(selectSurveyDomain, (state) => state.get("survey"))

export const makeSelectEngagement = () =>
  createSelector(selectSurveyDomain, (state) => state.get("engagement"))

export const makeSelectSurveyName = () =>
  createSelector(selectSurveyDomain, (state) => state.get("surveyName"))

export const makeSelectHasLikertQuestions = () =>
  createSelector(selectSurveyDomain, (state) => state.get("hasLikertQuestions"))

// GET DIMENSIONS QUESTION
export const makeSelectIsLoadingDimensionsQuestion = () =>
  createSelector(selectSurveyDomain, (state) =>
    state.get("isLoadingDimensionsQuestion")
  )

export const makeSelectDimensionsQuestion = () =>
  createSelector(selectSurveyDomain, (state) => state.get("dimensionsQuestion"))

// GET QUESTION TYPES
export const makeSelectIsLoadingQuestionTypes = () =>
  createSelector(selectSurveyDomain, (state) =>
    state.get("isLoadingQuestionTypes")
  )

export const makeSelectQuestionTypes = () =>
  createSelector(selectSurveyDomain, (state) => state.get("questionTypes"))

// GET QUESTION
export const makeSelectIsLoadingQuestion = () =>
  createSelector(selectSurveyDomain, (state) => state.get("isLoadingQuestion"))

export const makeSelectQuestion = () =>
  createSelector(selectSurveyDomain, (state) => state.get("question"))

// GET SURVEY ENPS
export const makeSelectIsLoadingSurveyEnps = () =>
  createSelector(selectSurveyDomain, (state) =>
    state.get("isLoadingSurveyEnps")
  )

export const makeSelectSurveyEnps = () =>
  createSelector(selectSurveyDomain, (state) => state.get("surveyEnps"))

// GET SURVEY ENPS
export const makeSelectIsLoadingSurveyQualitative = () =>
  createSelector(selectSurveyDomain, (state) =>
    state.get("isLoadingSurveyQualitative")
  )

export const makeSelectIsLoadingDeleteAllQuestions = () =>
  createSelector(selectSurveyDomain, (state) =>
    state.get("isLoadingDeleteAllQuestions")
  )

export const makeSelectSurveyQualitative = () =>
  createSelector(selectSurveyDomain, (state) => state.get("surveyQualitative"))

// GET DIMENSION
export const makeSelectIsLoadingDimension = () =>
  createSelector(selectSurveyDomain, (state) => state.get("isLoadingDimension"))

export const makeSelectDimension = () =>
  createSelector(selectSurveyDomain, (state) => state.get("dimension"))

// GET CONFIG SURVEY
export const makeSelectIsLoadingConfigSurvey = () =>
  createSelector(selectSurveyDomain, (state) =>
    state.get("isLoadingConfigSurvey")
  )

export const makeSelectConfigSurvey = () =>
  createSelector(selectSurveyDomain, (state) => state.get("configSurvey"))

// GET QUESTIONNARIES
export const makeSelectIsLoadingQuestions = () =>
  createSelector(selectSurveyDomain, (state) => state.get("isLoadingQuestions"))

export const makeSelectQuestions = () =>
  createSelector(selectSurveyDomain, (state) => state.get("questions"))

// UPLOAD IMAGE
export const makeSelectUploadBgImage = () =>
  createSelector(selectSurveyDomain, (state) => state.get("uploadBgImage"))

export const makeSelectIsLoadingUploadBgImage = () =>
  createSelector(selectSurveyDomain, (state) =>
    state.get("isLoadingUploadBgImage")
  )

// UPLOAD LOGO
export const makeSelectUploadLogo = () =>
  createSelector(selectSurveyDomain, (state) => state.get("uploadLogo"))

export const makeSelectIsLoadingUploadLogo = () =>
  createSelector(selectSurveyDomain, (state) =>
    state.get("isLoadingUploadLogo")
  )

export const makeSelectIsLoadingCreateQuestion = () =>
  createSelector(selectSurveyDomain, (state) =>
    state.get("isLoadingCreateQuestion")
  )

export const makeSelectIsErrorCreateQuestion = () =>
  createSelector(selectSurveyDomain, (state) =>
    state.get("isErrorCreateQuestion")
  )

export const makeSelectListQuestionMultipleChoice = () =>
  createSelector(selectSurveyDomain, (state) =>
    state.get("listQuestionMultipleChoice")
  )

export const makeSelectSegments = () =>
  createSelector(selectSurveyDomain, (state) => state.get("segments"))

export const makeSelectIsLoadingSegments = () =>
  createSelector(selectSurveyDomain, (state) => state.get("isLoadingSegments"))

export const makeSelectSurveyTypes = () =>
  createSelector(selectSurveyDomain, (state) => state.get("surveyTypes"))

export const makeSelectIsLoadingSurveyTypes = () =>
  createSelector(selectSurveyDomain, (state) =>
    state.get("isLoadingSurveyTypes")
  )

export const makeSelectScopeTypes = () =>
  createSelector(selectSurveyDomain, (state) => state.get("scopeTypes"))

export const makeSelectIsLoadingScopeTypes = () =>
  createSelector(selectSurveyDomain, (state) =>
    state.get("isLoadingScopeTypes")
  )

/**
 * Default selector used by Survey
 */

const makeSelectSurvey = () =>
  createSelector(selectSurveyDomain, (substate) => substate.toJS())

export default makeSelectSurvey
export { selectSurveyDomain }
